import { lazy, Suspense, useEffect, useState } from "react";
import "./App.css";
const ToastContainer = lazy(() =>
  import("react-toastify").then((mod) => ({ default: mod.ToastContainer }))
);
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
const Home = lazy(() => import("./components/Home/Home"));
import Logo from "../src/assets/images/logo.webp";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [spin, setSpin] = useState(false);
  useEffect(() => {
     window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();
    const script = document.createElement("script");
    script.src = "https://embed.tawk.to/682ad6b5de0d8619101f12f1/1irjlddr4";
    script.async = true;
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");
    document.body.appendChild(script);
    return () => {
      // Optional: cleanup on component unmount
      document.body.removeChild(script);
    };
  }, []);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000); // 3 seconds

    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    const timeout = setTimeout(() => setSpin(true), 1000); // 1 sec delay for spin
    return () => clearTimeout(timeout);
  }, []);
  if (isLoading) {
    return (
      <div className="flex items-center flex-col justify-center h-screen  transition-all duration-1000">
        <img src={Logo} alt="Logo" loading="lazy" className={`w-16 h-16 ${spin ? 'animate-spin' : ''}`}/>
      </div>
    );
  }
   

  return (
    <>
       <BrowserRouter>
      <Suspense>
        <ToastContainer position="top-center" />
      </Suspense>

      <Suspense>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </Suspense>
      </BrowserRouter>
    </>
  );
}

export default App;
